module.exports = __webpack_public_path__ + "img/p27.adbcd94b.svg";